import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "../components/css/style.css";

export default function CreativeCarousel() {
  const cards = [
    {
      id: 1,
      title: "Creative 1",
      subtitle: "Visual Storytelling",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938270/i80yqbsmmjqk9gwimmn7.png",
    },
    {
      id: 2,
      title: "Creative 2",
      subtitle: "Digital Innovation",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938270/nmndxvhsyl57ivvgqnds.png",
    },
    {
      id: 3,
      title: "Creative 3",
      subtitle: "Brand Identity",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938270/skue1jt2zqwkojsh8wfq.png",
    },
    {
      id: 4,
      title: "Creative 4",
      subtitle: "Motion Design",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938270/c99hkycm8ynsqlwowhne.png",
    },
    {
      id: 5,
      title: "Creative 5",
      subtitle: "Art Direction",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938271/ghj300sv3jr2s4evi7rd.png",
    },
    {
      id: 6,
      title: "Creative 6",
      subtitle: "UI/UX Design",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938272/a1jvaoepyaa0lmg4rpgl.png",
    },
    {
      id: 7,
      title: "Creative 7",
      subtitle: "UI/UX Design",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938272/mrdqovvqjlqeictwkwdg.png",
    },
    {
      id: 8,
      title: "Creative 8",
      subtitle: "UI/UX Design",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938272/dish1ygidmppgmygk9ye.png",
    },
    {
      id: 9,
      title: "Creative 9",
      subtitle: "UI/UX Design",
      img: "https://res.cloudinary.com/duxydukde/image/upload/v1775938272/lr5sk6qml2h2neevw9ma.png",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Scroll animation hooks for different sections
  const { ref: headerRef, inView: headerInView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const { ref: carouselRef, inView: carouselInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const { ref: thumbnailsRef, inView: thumbnailsInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex((prev) => (prev + 1) % cards.length);
  };

  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex((prev) => (prev - 1 + cards.length) % cards.length);
  };

  const goToSlide = (index) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };

  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }); 

  const handleMouseEnter = () => setIsAutoPlaying(false);
  const handleMouseLeave = () => setIsAutoPlaying(true);

  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? "100%" : "-100%",
      opacity: 0,
      scale: 0.95,
    }),
    center: {
      x: 0,
      opacity: 1,
      scale: 1,
      transition: {
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.4 },
        scale: { duration: 0.4 },
      },
    },
    exit: (direction) => ({
      x: direction > 0 ? "-100%" : "100%",
      opacity: 0,
      scale: 0.95,
      transition: {
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.3 },
        scale: { duration: 0.3 },
      },
    }),
  };

  const headerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
        staggerChildren: 0.2,
      },
    },
  };

  const carouselVariants = {
    hidden: { opacity: 0, scale: 0.95, y: 30 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1],
        delay: 0.2,
      },
    },
  };

  const thumbnailsVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        staggerChildren: 0.05,
        delayChildren: 0.3,
      },
    },
  };

  const thumbnailItemVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: "easeOut",
      },
    },
  };

  const currentCard = cards[currentIndex];

  return (
    <section className="carousel-showcase">
      <div className="blob-container">
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>
      
      <div className="carousel-bg-text">CREATIVE SHOWCASE</div>

      <div className="carousel-container">
        <motion.div
          ref={headerRef}
          className="carousel-header"
          variants={headerVariants}
          initial="hidden"
          animate={headerInView ? "visible" : "hidden"}
        >
          <motion.h2 variants={headerVariants}>
            Social Media <span className="highlight">Posts</span>
          </motion.h2>
          <motion.p variants={headerVariants}>
            Curated collection of stunning creative works
          </motion.p>
        </motion.div>

        <motion.div
          ref={carouselRef}
          className="carousel-wrapper"
          variants={carouselVariants}
          initial="hidden"
          animate={carouselInView ? "visible" : "hidden"}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <motion.button
            className="nav-btn prev-btn"
            onClick={prevSlide}
            whileHover={{ scale: 1.1, x: -3 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </motion.button>

          <motion.button
            className="nav-btn next-btn"
            onClick={nextSlide}
            whileHover={{ scale: 1.1, x: 3 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </motion.button>

          <div className="carousel-slide-container">
            <AnimatePresence initial={false} custom={direction} mode="wait">
              <motion.div
                key={currentIndex}
                custom={direction}
                variants={slideVariants}
                initial="enter"
                animate="center"
                exit="exit"
                className="carousel-card"
              >
                <div className="card-image">
                  <img src={currentCard.img} alt={currentCard.title} />
                  <div className="image-overlay"></div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <motion.div
            ref={thumbnailsRef}
            className="thumbnail-nav"
            variants={thumbnailsVariants}
            initial="hidden"
            animate={thumbnailsInView ? "visible" : "hidden"}
          >
            {cards.map((card, idx) => (
              <motion.button
                key={card.id}
                className={`thumbnail ${idx === currentIndex ? "active" : ""}`}
                onClick={() => goToSlide(idx)}
                variants={thumbnailItemVariants}
                whileHover={{ scale: 1.08, y: -5 }}
                whileTap={{ scale: 0.95 }}
                animate={
                  idx === currentIndex
                    ? {
                        borderColor: ["#149fa2", "#0350aa", "#149fa2"],
                        boxShadow: [
                          "0 0 5px rgba(20, 159, 162, 0.3)",
                          "0 0 20px rgba(20, 159, 162, 0.8)",
                          "0 0 5px rgba(20, 159, 162, 0.3)",
                        ],
                      }
                    : {}
                }
                transition={{
                  borderColor: { duration: 1.5, repeat: Infinity },
                  boxShadow: { duration: 1.5, repeat: Infinity },
                }}
              >
                <img src={card.img} alt={`Thumb ${idx + 1}`} />
                <div className="thumbnail-overlay"></div>
              </motion.button>
            ))}

            <motion.div
              className="slide-counter"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.5 }}
            >
              <span className="current">{String(currentIndex + 1).padStart(2, "0")}</span>
              <span className="separator">/</span>
              <span className="total">{String(cards.length).padStart(2, "0")}</span>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
